var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22416 9.2411L6.28166 10.2986L5.53166 11.0486C4.71307 11.8672 3.51996 12.1869 2.40174 11.8873C1.28353 11.5876 0.410109 10.7142 0.110485 9.59601C-0.189139 8.4778 0.130556 7.28469 0.949144 6.4661L2.92915 4.5011C4.19621 3.23963 6.24461 3.23963 7.51167 4.5011L7.75917 4.7561L6.72417 5.7761L6.46917 5.5286C6.14515 5.20111 5.7036 5.01684 5.24291 5.01684C4.78222 5.01684 4.34067 5.20111 4.01666 5.5286L2.00665 7.5386C1.32941 8.21998 1.33276 9.32136 2.01415 9.9986C2.69553 10.6758 3.79692 10.6725 4.47416 9.9911L5.22416 9.2411ZM11.0592 0.946103C9.79212 -0.315368 7.74373 -0.315368 6.47667 0.946103L5.72666 1.6961L6.72417 2.7611L7.47417 2.0111C7.91897 1.56631 8.56727 1.39259 9.17488 1.5554C9.78248 1.71821 10.2571 2.1928 10.4199 2.8004C10.5827 3.408 10.409 4.05631 9.96418 4.5011L7.95417 6.5111C7.63016 6.83859 7.18861 7.02287 6.72792 7.02287C6.26723 7.02287 5.82568 6.83859 5.50166 6.5111L5.22416 6.2261L4.16666 7.2836L4.41416 7.5386C5.68122 8.80007 7.72961 8.80007 8.99668 7.5386L11.0067 5.5286C12.2744 4.26775 12.2845 2.21934 11.0292 0.946103H11.0592Z",
    fill: "#5E81F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainIcon);
export default __webpack_public_path__ + "static/media/chain_icon.cf929334bc21461652b2e6e37342bb70.svg";
export { ForwardRef as ReactComponent };